const PlainLayout = ({ children }) => {
  return <main>{children}</main>;
};
export default PlainLayout;
